import { render } from '@testing-library/react';
import { VocabProvider } from '@vocab/react';
import { BraidTestProvider } from 'braid-design-system/test';
import type * as React from 'react';
import { type BaseConfig, ConfigProvider, AppContextProvider } from '..';
import {
  type Language,
  siteConfig,
  type SiteName,
  createAbsoluteUrl,
  type Country,
} from '@seek/melways-sites';
import { MelwaysProvider } from '@seek/melways-react';

export const testRenderer = (
  Component: React.ElementType,
  props: Record<string, unknown> = {},
  language: Language = 'en',
  siteName: SiteName = 'candidate-seek-au',
) => {
  const site = siteConfig[siteName];
  const country = site.classification.country;

  const config: BaseConfig = {
    language,
    siteName,
    country: country as Country,
    locale: 'en-AU',
    zone: 'anz-1',
    brand: 'seek',
    environment: 'production',
    product: 'candidate',
    name: 'Company Profiles',
    experience: 'candidate',
  };

  const absoluteUrl = createAbsoluteUrl({
    product: site.classification.product,
    country: country as Country,
    path: '/',
    language,
    consolidated: site.classification.consolidated,
  });

  return render(
    <ConfigProvider config={config}>
      <MelwaysProvider.Server site={config.siteName} url={absoluteUrl}>
        <AppContextProvider
          advertiserId="1"
          companyId="1"
          companyName="Test Company"
          userId="1"
        >
          <BraidTestProvider>
            <VocabProvider language={config.language}>
              <Component {...props} />
            </VocabProvider>
          </BraidTestProvider>
        </AppContextProvider>
      </MelwaysProvider.Server>
    </ConfigProvider>,
  );
};
